import { useStore } from 'vuex'
import { ref, computed } from 'vue'

export default {
    name: 'MaterialCard',
    props: {
        data: {
            type: Object,
            required: true
        },
        showAddCta: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const store = useStore();

        var desktopImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:430,height:608')
        var mobileImageUrl = computed(() => props.data.imageUrl + '?io=transform:fill,width:215,height:304')
        const isSubmitting = ref(false);
        const isAdded = ref(false)

        const addToCart = async () => {
            
            if (!props.data.sku) {
                window.location.href = props.data.url
                return
            }
            
            if (isAdded.value || isSubmitting.value)
                return

            isSubmitting.value = true;
            await store.dispatch("basket/addToBasket", {
                sku: props.data.sku,
                quantity: 1
            })
            isSubmitting.value = false;
            isAdded.value = true;
        };

        return {
            desktopImageUrl,
            mobileImageUrl,
            isAdded,
            isSubmitting,
            addToCart
        }
    }
}
